import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/polaris'),
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.POLARIS,
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'POLARIS_SETTINGS.TITLE',
        icon: 'i-lucide-bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'polaris_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.POLARIS,
          },
        },
      ],
    },
  ],
};
